var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlenderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_56_189)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 90,
    height: 90,
    rx: 20,
    fill: "url(#paint0_linear_56_189)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_56_189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.6013 48.7913C50.74 46.29 51.9625 44.0888 53.8113 42.525C55.7523 40.9105 58.2015 40.0339 60.7263 40.05C63.3888 40.05 65.8263 40.9875 67.645 42.525C69.49 44.0888 70.7163 46.2938 70.855 48.7913C70.9975 51.3638 69.9663 53.7525 68.1513 55.5225C66.1534 57.4286 63.4911 58.4806 60.73 58.455C57.9664 58.4821 55.3012 57.43 53.3013 55.5225C51.49 53.7525 50.455 51.3638 50.6013 48.7913Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_56_189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.465 53.8538C34.4837 54.8288 34.7987 56.73 35.2637 58.2188C36.2769 61.4206 37.9764 64.3627 40.2437 66.84C42.6741 69.5148 45.6429 71.6452 48.955 73.0913C52.5576 74.6806 56.4549 75.492 60.3925 75.4725C64.3336 75.4774 68.2317 74.6533 71.8337 73.0538C75.1414 71.5902 78.1062 69.4506 80.5375 66.7725C82.8001 64.2873 84.4966 61.3408 85.51 58.1363C86.0046 56.5709 86.3191 54.9542 86.4475 53.3175C86.801 48.5851 85.6344 43.8633 83.1175 39.84C81.5813 37.3837 79.6194 35.2211 77.3237 33.4538L77.3275 33.45L53.8937 15.4538L53.8337 15.4013C52.2925 14.2238 49.705 14.2275 48.0175 15.4088C46.3037 16.605 46.1125 18.5813 47.6275 19.8338L47.6237 19.8375L57.3962 27.7913L27.61 27.825H27.565C25.105 27.825 22.7387 29.445 22.27 31.485C21.79 33.5663 23.4625 35.2913 26.0237 35.2988L26.02 35.31L41.1212 35.28L14.1662 55.965L14.065 56.0438C11.5262 57.99 10.705 61.2263 12.3025 63.2775C13.93 65.3625 17.38 65.3625 19.9525 63.285L34.66 51.2513C34.6637 51.2513 34.45 52.875 34.465 53.8538ZM72.2575 59.2913C69.2275 62.3813 64.99 64.1325 60.3962 64.14C55.7987 64.1475 51.5612 62.4113 48.5275 59.3288C47.0933 57.8932 45.9879 56.1633 45.2875 54.2588C44.6259 52.4477 44.3711 50.5132 44.5412 48.5925C44.7062 46.6988 45.265 44.8913 46.1687 43.26C47.0537 41.6513 48.2762 40.2038 49.7762 38.97C52.7849 36.5507 56.5355 35.2422 60.3962 35.265C64.2532 35.234 68.0033 36.5317 71.0162 38.94C72.5125 40.1625 73.735 41.6063 74.62 43.2113C75.52 44.8463 76.0825 46.6463 76.2475 48.54C76.4167 50.4604 76.1633 52.3944 75.505 54.2063C74.7974 56.1135 73.6901 57.8472 72.2575 59.2913Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_56_189",
    x: 0,
    y: 0,
    width: 98,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_56_189"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_56_189",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_56_189",
    x: 46.5876,
    y: 40.0498,
    width: 28.2805,
    height: 26.4058,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_56_189"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_56_189",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_56_189",
    x: 7.48389,
    y: 14.5205,
    width: 83.0255,
    height: 68.9524,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_56_189"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_56_189",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_56_189",
    x1: 49,
    y1: 0,
    x2: 49,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6B00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlenderIcon);
export default __webpack_public_path__ + "static/media/blender_icon.60615c49e4107fde1574a9f37715acc3.svg";
export { ForwardRef as ReactComponent };